import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PreviewStage.css';
import Btn from '../../button/btn/Btn';
import sanitizeHtml from '../../../library/sanitizeHtml';
import {useVariables} from '../../../assets/objects/Variables';
import {convertVariablesToHtml} from '../../textEditor/Variables';
import {useSelector} from 'react-redux';
import {useFormikContext} from 'formik';

const PreviewStage = ({onEdit}: {onEdit: () => void;}) => {
    const {t} = useTranslation('suspendedConfirmation');
    const {currentLang, data} = useSelector((s:any) => ({
        currentLang: s.branding.currentLang,
        data: s.branding.data,
    }));
    const {arrivalConfirmation} = data?.[currentLang || 'he'] ?? {arrivalConfirmation: {emailContent: ''}};
    const {defaultVariables} = useVariables();
    const {t: tVariables} = useTranslation('variables');
    const htmlWithValues = arrivalConfirmation.emailContent
        ? convertVariablesToHtml(arrivalConfirmation.emailContent, defaultVariables, tVariables) 
        : '';
    const content = htmlWithValues?.replace(/\n/g, '</p><p>');
    const form = useFormikContext();

    return (
        <>
            <css.contentContainer>
                <css.previewContent 
                    dangerouslySetInnerHTML={sanitizeHtml(content)} 
                />
            </css.contentContainer>
            <css.buttonContainer>
                <Btn onClick={onEdit} className='white'>
                    {t('confirmationEdit')}
                </Btn>
                <Btn onClick={form.handleSubmit}>
                    {t('confirmationSent')}
                </Btn>
            </css.buttonContainer>
        </>
    );
};

export default PreviewStage;
